import React from "react"
const WarningIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" className="text-red-600">
    <polygon points="12,2 22,20 2,20" fill="none" stroke="currentColor" strokeWidth="2" />
    <text x="12" y="17" textAnchor="middle" fontSize="12" fill="currentColor" fontWeight="bold">!</text>
  </svg>
);
export default WarningIcon
